// Ensure API_BASE_URL has a trailing slash for proper URL construction
const getApiBaseUrl = () => {
  const url = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000';
  return url.endsWith('/') ? url : `${url}/`;
};

export const API_BASE_URL = getApiBaseUrl();
export const MAP_BOX_TOKEN = process.env.REACT_APP_MAP_BOX_TOKEN;
export const BASE_IMAGE_URL = process.env.REACT_APP_BASE_IMAGE_URL;
